// Generated by purs version 0.15.15
import * as Unsafe_Coerce from "../Unsafe.Coerce/index.js";
var toEffect = Unsafe_Coerce.unsafeCoerce;
export {
    toEffect
};
